import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgRetroalimentacionAltoVolumenPronostico from "../../assets/tests/scn3/final-os.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconIdBadge2, IconClipboardList } from "@tabler/icons-react";

function Scenario3FinalOsResults({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div
            className="col-md-12 d-flex justify-content-start align-items-start px-5 pt-5"
            style={{ marginBottom: "2vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100">
              <p className="txt30 txt-purple bold w-100" style={{ backgroundColor: "#FFFFFFAA", borderRadius: "10px", padding: "20px"}}>Final OS Results for Phase III Trials of ARPI + ADT in Patients With mHSPC</p>
              <img src={imgRetroalimentacionAltoVolumenPronostico} className="rounded shadow" style={{ maxWidth: "90%", borderRadius: "12px", maxHeight: "700px" }}></img>
              <div className="mt-3 d-flex align-items-center justify-content-end w-100">
                {/* Botón siguiente */}
                <NextButton
                  navigateTo={ROUTES.SCENARIO3_PEACEI}
                  activeScenario={activeScenario}
                  color="violet"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario3FinalOsResults);
